import { useAppSelector } from '@store/hooks'
import { selectSelectedUser } from '@store/UserReducer'
import { Card, Col, Empty, Row, Space, Spin, Typography } from 'antd'
import MembershipProfileSectionsLayout from './MembershipProfileSectionsLayout'

const { Text } = Typography

const UserMembershipLayout = () => {
  const user = useAppSelector(selectSelectedUser())

  if (!user) {
    return <Spin />
  }

  if (!user.membershipProfileId) {
    return (
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Card styles={{ body: { padding: 50 } }}>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <Space orientation="vertical" size={5}>
                  <Text>This user hasn't subscribed to a membership yet.</Text>
                  If they have already purchased a plan, they must activate it in
                  the app using their activation code.
                </Space>
              }
            />
          </Card>
        </Col>
      </Row>
    )
  }

  return <MembershipProfileSectionsLayout id={user.membershipProfileId} />
}

export default UserMembershipLayout
